import axios from 'axios';
import { Product } from '../types/Product';

const API_URL = 'http://localhost:8080/api';

// Create an axios instance with default config
const apiClient = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  }
});

export const api = {
    getAllProducts: async (): Promise<Product[]> => {
        const response = await apiClient.get('/products');
        return response.data;
    },

    getProductById: async (id: number): Promise<Product> => {
        const response = await apiClient.get(`/products/${id}`);
        return response.data;
    },

    getProductsByCategory: async (category: string): Promise<Product[]> => {
        const response = await apiClient.get(`/products/category/${category}`);
        return response.data;
    },

    getFeaturedProducts: async (): Promise<Product[]> => {
        const response = await apiClient.get('/products/featured');
        return response.data;
    },

    searchProducts: async (query: string): Promise<Product[]> => {
        const response = await apiClient.get(`/products/search?query=${query}`);
        return response.data;
    },

    createProduct: async (product: Omit<Product, 'id'>): Promise<Product> => {
        const response = await apiClient.post('/products', product);
        return response.data;
    },

    updateProduct: async (id: number, product: Product): Promise<Product> => {
        const response = await apiClient.put(`/products/${id}`, product);
        return response.data;
    },

    deleteProduct: async (id: number): Promise<void> => {
        await apiClient.delete(`/products/${id}`);
    }
}; 